module.exports = __webpack_public_path__ + "static/media/ep2.93787b28.jpg";